module.exports = __webpack_public_path__ + "static/media/img-active_off.77f8ed57.svg";